module.exports = __webpack_public_path__ + "img/op2.f9ab1cff.png";